/* eslint-disable react/jsx-props-no-spreading */

import classNames from 'classnames';

import ProductBadge from '../../../../../common/components/atoms/ProductBadge';
import { mapProductAttributeToProps } from '../../../../../common/utils/productUtils';
import type { ProductDetailsData } from '../ProductDetailsPage.types';
import styles from './ProductDetails.module.scss';

interface ProductDetailsLabelsProps {
    product: ProductDetailsData;
    orientation: 'horizontal' | 'vertical';
}

const ProductDetailsLabels = ({
    product,
    orientation,
}: React.PropsWithChildren<ProductDetailsLabelsProps>) => {
    const labels = product.attributeLabels.map(mapProductAttributeToProps).filter(Boolean);

    if (labels.length === 0) {
        return null;
    }

    return (
        <ul
            className={classNames(styles.Labels, orientation === 'horizontal' && styles.Horizontal)}
            aria-label="Märkt med"
        >
            {labels.map((badge, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index}>
                    <ProductBadge
                        focusable
                        dimensions={{ width: 32, height: 'auto' }}
                        zoomable
                        zoomDimensions={{ width: 64, height: 'auto' }}
                        url={badge.url}
                        alt={badge.alt}
                    />
                </li>
            ))}
        </ul>
    );
};

export default ProductDetailsLabels;
